<template>
  <div id="business-block-time">
    <div class="content" v-if="businessBlockTimeList">
      <vx-card v-if="businessBlockTimeList.items && businessBlockTimeList.items.length == 0" style="border-radius: 10px;">
          <!-- <h4>Time Off For Business</h4> -->
         <div class="no-timeoff-container flex flex-col align-center justify-center">
          <h5 class="text-center">Add time off by clicking the button below.</h5>
          <vs-button color="primary" type="filled" icon="add_circle_outline" @click="addTimeOff">Add Time Off</vs-button>
         </div>
      </vx-card>
      <vx-card v-else class="border-0" style="border-radius: 10px;">
        <div class="w-full">
            <div class="flex justify-between align-center pr-4">
              <p class="text-2xl py-3">
                Time Off For Business:
              </p>
              <vs-button @click="addTimeOff" style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;">
                <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current" style="transform: translateY(3px)"/>
              </vs-button>
            </div>
            <div class="border-bottom-custom mb-6" v-if="businessBlockTimeList && businessBlockTimeList.items">
              <div v-for="(business, index) in businessBlockTimeList.items" :key="index" @click="updateTimeOff(business)">
                <div class="flex block-time border-top-custom p-4 cursor-pointer" v-if="business.all_day != 1">
                  <div class="flex w-1/2 pr-4">
                    <div class="my-clock-icon">
                      <feather-icon icon="ClockIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                    </div>
                    <div class="day-distance-container">
                      <p class="day-distance pb-1">{{getFormatDate(business.start_date)}}<span v-if="getFormatDate(business.start_date) != getFormatDate(business.end_date)"> to {{getFormatDate(business.end_date)}}</span></p>
                      <p class="description text-sm text-grey-custom" v-if="business.description == ''">No Description</p>
                      <p class="description text-sm text-grey-custom" v-else>{{business.description}}</p>
                    </div>
                  </div>
                  <div class="flex text-grey-custom text-sm w-1/2">
                    <p class="mr-4 w-1/3 text-center flex-center" v-if="business.data && business.recurring == '1'">
                      Every
                      <span v-if="business.data.recurring_type == 'monthly'">Month</span>
                      <span v-else>Week</span>
                    </p>
                    <p class="mr-4 w-1/3 text-center flex-center" v-else>No repeat</p>
                    <p class="mr-4 w-5/12 text-center flex-center">{{getFormatTime(business.start_date)}} to {{getFormatTime(business.end_date)}}</p>
                    <div class="w-1/4 flex justify-end my-auto">
                      <!-- <vs-button color="orange" style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;" @click.stop="openDeletePopup(business)">
                        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" style="transform: translateY(3px)"/>
                      </vs-button> -->
                      <img src="../../assets/images/trash-icon.png" class="trash-icon mx-2" @click.stop="openDeletePopup(business)" />
                    </div>
                  </div>
                </div>

                <div class="flex block-time border-top-custom p-4 cursor-pointer" v-else>
                  <div class="flex w-1/2 pr-4">
                    <div class="my-clock-icon">
                      <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                    </div>
                    <div class="day-distance-container">
                      <p class="day-distance pb-1">{{getFormatDate(business.start_date)}}</p>
                      <p class="description text-sm text-grey-custom" v-if="business.description == ''">No Description</p>
                      <p class="description text-sm text-grey-custom" v-else>{{business.description}}</p>
                    </div>
                  </div>
                  <div class="flex text-grey-custom text-sm w-1/2">
                    <p class="mr-4 w-1/3 text-center flex-center" v-if="business.data && business.recurring == '1'">
                      Every
                      <span v-if="business.data.recurring_type == 'monthly'">Month</span>
                      <span v-else>Week</span>
                    </p>
                    <p class="mr-4 w-1/3 text-center flex-center" v-else>No repeat</p>
                    <p class="mr-4 w-5/12 text-center flex-center" v-if="business.data && business.recurring == '1'">Fullday</p>
                    <p class="mr-4 w-5/12 text-center flex-center" v-else>All day</p>

                    <div class="w-1/4 flex justify-end my-auto">
                      <!-- <vs-button color="orange" style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;" @click.stop="openDeletePopup(business)">
                        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" style="transform: translateY(3px)"/>
                      </vs-button> -->
                      <img src="../../assets/images/trash-icon.png" class="trash-icon mx-2" @click.stop="openDeletePopup(business)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="businessBlockTimeList && businessBlockTimeList._meta && businessBlockTimeList._meta.pageCount && businessBlockTimeList._meta.pageCount > 1">
            <custom-pagination
              class="custom-pagination"
              :totalPages="parseInt(businessBlockTimeList._meta.pageCount)"
              :currentPage="currentPage"
              @pageChanged="changePage"
              :key="page_key"
            ></custom-pagination>
          </div>
      </vx-card>
    </div>
    <vs-popup class="holamundo delete-block-time" title="Delete Item" :active.sync="popupActive">
      <div class="text-center">
        <h3>Do you want to delete this block time?</h3>
        <div class="flex flex-wrap items-center align-center p-6 justify-center">
          <vs-button class="mr-6 align-center delete-responsive" @click="deleteTimeOff">Delete</vs-button>
          <vs-button type="border" color="danger" class="cancel-responsive" @click="popupActive = false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
    <add-time-off :activePromptAddEvent="activePromptAddEvent" :typeBlock="type" :currentPage="currentPage" :itemsPerpage="itemsPerpage"></add-time-off>
    <update-time-off :activePromptUpdateEvent="activePromptUpdateEvent" :action_type="action_type" :blockTimeData="blockTimeData" :key="'A' + updateKey" :currentPage="currentPage" :itemsPerpage="itemsPerpage"></update-time-off>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'business-block-time',
  data(){
    return{
      hasList : false,
      activePromptAddEvent: {
        isOpen : false
      },
      activePromptUpdateEvent: {
        isOpen : false
      },
      type: 'business',
      blockTimeData: {},
      updateKey: 0,
      popupActive: false,
      action_type: '',
      isOpenLoading: false,
      loaded_data_num: 0,
      currentPage: 1,
      itemsPerpage: 5,
      page_key: 0
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' block time failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    changePage(page) {
      const obj = {
        filterType : 1,
        page: page,
        'per-page': this.itemsPerpage
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = 'Get list';
      this.$store.dispatch("business/LIST_BUSINESS_BLOCK_TIME", obj).then(() => {
        this.currentPage = page;
        this.page_key++;
        this.closeLoading();
      })
    },
    getFormatTime(date){
      let stringTime = '';
      if(parseInt(date.slice(10,13)) < 12){
        if(parseInt(date.slice(10,13)) == 0){
          stringTime = String(parseInt(date.slice(10,13)) + 12) + date.slice(13,16) + ' am';
        }else{
          stringTime = String(parseInt(date.slice(10,13))) + date.slice(13,16) + ' am';
        }
      }else{
        if(parseInt(date.slice(10,13)) == 12){
          stringTime = String(parseInt(date.slice(10,13))) + date.slice(13,16) + ' pm';
        }else{
          stringTime = String(parseInt(date.slice(10,13)) - 12) + date.slice(13,16) + ' pm';
        }
      }
      return stringTime;
    },
    getFormatDate(date){
      return moment(date).format('LL');
    },
    updateTimeOff(business){
      this.action_type = 'Update';
      this.activePromptUpdateEvent.isOpen = true;
      this.blockTimeData = business;
      this.updateKey++;
    },
    addTimeOff(){
      this.action_type = 'Add';
      this.activePromptAddEvent.isOpen = true;
    },
    openDeletePopup(business) {
      this.blockTimeData = business;
      this.popupActive = true;
    },
    deleteTimeOff() {
      let isLastItem = false;
      if(this.businessBlockTimeList && this.businessBlockTimeList.items && this.businessBlockTimeList.items.length == 1) {
        isLastItem = true;
      }
      if(this.blockTimeData) {
        let obj = {
          id: this.blockTimeData.id,
          type: 1,
          page: this.currentPage,
          'per-page': this.itemsPerpage
        }
        this.action_type = 'Delete';
        this.openLoadingInDiv();
        this.$store.dispatch('business/DELETE_BUSINESS_TIME_OFF', obj).then(() => {
          this.popupActive = false;
          if(isLastItem && this.currentPage > 1) {
            this.currentPage--;
          }
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Block Time Success',
            color:'success',
            position:'top-right'})
        }).catch(() => {
          this.popupActive = false;
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Block Time Failed',
            color:'danger',
            position:'top-right'})
        })
      }
    }
  },
  computed:{
    businessBlockTimeList() {
      return this.$store.getters["business/listBusinessBlockTime"];
    }
  },
  created(){
    const obj = {
      filterType : 1,
      page: this.currentPage,
      'per-page': this.itemsPerpage
    }
    this.$store.dispatch("business/LIST_BUSINESS_BLOCK_TIME", obj).then(() => {
      this.loaded_data_num++;
      this.$emit('LoadDataComplete');
    })
  }
}
</script>
